export const fetchTemplates = ({ commit }, { recipient }) => {
  return axios.get(`/chat-templates?recipient=${recipient}`).then((res) => {
    commit('setTemplates', res.data)
  })
}

export const createTemplate = ({ commit }, data) => {
  return axios.post('/chat-templates', data).then((res) => {
    commit('addTemplate', res.data)
    Vuemit.fire('ChatTemplate--success', true)
  }).catch((e) => {    
    Vuemit.fire('ChatTemplate--has-errors', e.response.data.errors)
  })
}

export const updateTemplate = ({ commit }, data) => {  
  return axios.put(`/chat-templates/${data.id}`, data).then((res) => {
    commit('updateTemplate', res.data)
    Vuemit.fire('ChatTemplate--success', true)
  }).catch((e) => {    
    Vuemit.fire('ChatTemplate--has-errors', e.response.data.errors)
  })
}

export const deleteTemplate = ({ commit }, data) => {
  return axios.delete(`/chat-templates/${data.id}`).then((res) => {
    commit('removeTemplate', data)
  })
}

export const findTemplate = ({ state }, templateId) => {
  return _.find(state.templates, { id: templateId })
}
